export default "__VITE_ASSET__DvzE4pKL__"